import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { BasicProfileRouteData } from '../registration/basic-profile/basic-profile.domain';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-guest',
  templateUrl: './guest.component.html',
  styleUrls: ['./guest.component.scss'],
})
export class GuestComponent implements OnInit {
  public enabled: boolean = false;

  constructor() {}

  @Input() routeData: BasicProfileRouteData;

  ngOnInit(): void {}
}
